import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-[1400px] mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-500 mb-3">
            Browse by Category
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Discover <span className="text-accent-500">Curated</span><br />
            Product Collections
          </h2>
        </div>

        {/* Feature cards row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
          {/* Large Shoes card */}
          <a
            href={categories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group overflow-hidden rounded-2xl md:row-span-2 cursor-pointer"
          >
            <div className="aspect-[3/4] md:aspect-[4/5] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20suede%20desert%20boots%20in%20warm%20cognac%20brown%20resting%20on%20textured%20terracotta%20surface%2C%20morning%20sunlight%20streaming%20through%20linen%20curtains%2C%20artisanal%20product%20photography%2C%20rich%20material%20texture%20with%20visible%20grain%20and%20stitching%20detail%2C%20rustic%20Mediterranean%20aesthetic%2C%20soft%20golden%20hour%20glow%2C%20editorial%20lifestyle%20catalog%20style&width=700&height=900&seq=cat-v2-shoes-feature&orientation=portrait"
                alt="Superbuy Shoes Spreadsheet - premium sneakers collection"
                title="Superbuy Shoes Spreadsheet"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="inline-block px-4 py-2 bg-background-50/90 backdrop-blur-sm text-foreground-950 text-sm font-semibold rounded-lg">
                  Shoes Collection
                </span>
              </div>
            </div>
          </a>

          {/* Hoodies card */}
          <a
            href={categories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group overflow-hidden rounded-2xl cursor-pointer"
          >
            <div className="aspect-[3/2] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20forest%20green%20knit%20sweater%20draped%20over%20natural%20linen%20fabric%2C%20soft%20diffused%20window%20light%2C%20cozy%20editorial%20product%20photography%2C%20rich%20cable%20knit%20texture%20with%20intricate%20pattern%20detail%2C%20warm%20earthy%20woodland%20palette%2C%20contemporary%20artisan%20aesthetic%2C%20gentle%20shallow%20depth%20of%20field&width=700&height=470&seq=cat-v2-hoodies-feature&orientation=landscape"
                alt="Superbuy Hoodies Sweaters Spreadsheet"
                title="Superbuy Hoodies Spreadsheet"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-4 py-2 bg-background-50/90 backdrop-blur-sm text-foreground-950 text-sm font-semibold rounded-lg">
                  Hoodies &amp; Sweaters
                </span>
              </div>
            </div>
          </a>

          {/* T-Shirts card */}
          <a
            href={categories[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative group overflow-hidden rounded-2xl cursor-pointer"
          >
            <div className="aspect-[3/2] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20rust%20colored%20premium%20cotton%20t-shirt%20elegantly%20folded%20on%20light%20oak%20wood%20surface%2C%20golden%20afternoon%20light%2C%20minimalist%20product%20photography%20with%20rich%20warm%20terracotta%20undertones%2C%20visible%20fine%20cotton%20weave%20texture%2C%20gentle%20shadow%20play%2C%20refined%20casual%20wear%20catalog%20aesthetic&width=700&height=470&seq=cat-v2-tshirts-feature&orientation=landscape"
                alt="Superbuy T-Shirts Spreadsheet"
                title="Superbuy T-Shirts Spreadsheet"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-4 py-2 bg-background-50/90 backdrop-blur-sm text-foreground-950 text-sm font-semibold rounded-lg">
                  T-Shirts
                </span>
              </div>
            </div>
          </a>
        </div>

        {/* Category pill buttons */}
        <div className="flex flex-wrap justify-center gap-3 mt-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200/70 text-foreground-700 text-sm font-medium rounded-full hover:bg-accent-50 hover:border-accent-200 hover:text-accent-700 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}